import { isUpdateDeliveryChannelErrorResponse, Name as ErrorEventName } from '@ori-events/update-delivery-channel-failed';
import { putRequestOptions } from '../constants/requestOptions';
import { RequestUrl } from '../types';
import { convertToCamelCase } from '../utils';
export async function updateDeliveryChannelHandler({
  detail: {
    deliveryChannelId
  }
}) {
  const requestOptions = {
    ...putRequestOptions,
    body: JSON.stringify({
      deliveryChannelId
    })
  };
  const response = await fetch(RequestUrl.UpdateDeliveryChannel, requestOptions);
  const data = convertToCamelCase(await response.json());
  if (isUpdateDeliveryChannelErrorResponse(data)) {
    const errorEvent = new CustomEvent(ErrorEventName, {
      detail: data
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  return data;
}
//# sourceMappingURL=updateDeliveryChannelHandler.js.map